import { ROLES } from '@tempus/trials-types';

/** Matches `PROGRAM_MANAGEMENT_USER` in trials `roles.export.ts` */
export const PROGRAM_MANAGEMENT_USER_ROLE = 'PROGRAM_MANAGEMENT_USER';

/**
 * Program Management nav and routes: T_ADMIN or PROGRAM_MANAGEMENT_USER, matching the trials API. Uses effective
 * roles, so it is hidden while impersonating a site.
 */
export const canAccessProgramManagement = (effectiveRoles: string[]): boolean =>
  effectiveRoles.includes(ROLES.T_ADMIN) || effectiveRoles.includes(PROGRAM_MANAGEMENT_USER_ROLE);
